import { appConfig } from '~/app.config';
import { AdviceInterface } from '~/attendee/interfaces/advice.interface';

export class Advice implements AdviceInterface {
  public id: string;
  public locale: string;
  public summary: string;
  public teaserImage?: {
    alt_title: string;
    file_name: string;
    media_id: string;
    security_key: string;
  };
  public title: string;
  public url: string;

  constructor(init: Partial<Advice>) {
    Object.assign(this, init);
  }

  public get imageUrl(): string {
    const image = this.teaserImage;

    if (!image) {
      return appConfig.defaultImage;
    }

    return `${appConfig.pixl.url}/${image.media_id}/${image.security_key}/${image.file_name}?f=500x500`;
  }
}
